import type { JSX } from 'react';
import { Box } from '@ksyos/design-system';
import { ChartCircle } from './ChartCircle';
import { ChartDottedLine } from './ChartDottedLine';
import { ChartTriangle } from './ChartTriangle';

export type ChartLegendIconType =
    | 'triangle-red'
    | 'triangle-blue'
    | 'circle-magenta'
    | 'circle-lime'
    | 'dotted-line'
    | 'solid'
    | 'solid-gray';

type ChartLegendIconProps = {
    icon: ChartLegendIconType;
};

export function ChartLegendIcon(props: ChartLegendIconProps): JSX.Element | null {
    const { icon } = props;

    switch (icon) {
        case 'circle-magenta':
            return <ChartCircle color="magenta" />;
        case 'circle-lime':
            return <ChartCircle color="lime" />;
        case 'triangle-red':
            return <ChartTriangle color="red" />;
        case 'triangle-blue':
            return <ChartTriangle color="blue" />;
        case 'dotted-line':
            return <ChartDottedLine />;
        case 'solid':
            return (
                <Box
                    backgroundColor="neutral100"
                    border="1.5px solid"
                    borderColor="neutral200"
                    borderRadius="md"
                    height={20}
                    width={33}
                />
            );
        case 'solid-gray':
            return (
                <Box
                    backgroundColor="neutral300"
                    border="1.5px solid"
                    borderColor="neutral400"
                    borderRadius="md"
                    height={20}
                    width={33}
                />
            );
        default:
            return null;
    }
}
